import { useEffect } from 'react';

// Comportement commun des panneaux du collectif poses sur l'atelier (refonte, 2026-10-24) :
//   - a l'ouverture, le focus va sur `premierRef` (ou le panneau lui-meme) ; a la fermeture, il revient a ce qui l'avait avant
//     (le bouton Inviter) ;
//   - Echap ferme ; Tab reste dans le panneau.
export default function usePanneauAccessible(panneauRef, onClose, premierRef = null) {
  useEffect(() => {
    const precedent = document.activeElement;
    const minuteur = setTimeout(() => (premierRef?.current || panneauRef.current)?.focus(), 30);
    return () => {
      clearTimeout(minuteur);
      if (precedent && typeof precedent.focus === 'function' && document.contains(precedent)) precedent.focus();
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    const surTouche = (event) => {
      if (event.key === 'Escape') { event.preventDefault(); onClose(); return; }
      if (event.key !== 'Tab' || !panneauRef.current) return;
      const focusables = [...panneauRef.current.querySelectorAll('button, input, textarea, select, a[href], summary, [tabindex]:not([tabindex="-1"])')]
        .filter((el) => !el.disabled && el.offsetParent !== null);
      if (focusables.length === 0) return;
      const premier = focusables[0];
      const dernier = focusables[focusables.length - 1];
      if (event.shiftKey && document.activeElement === premier) { event.preventDefault(); dernier.focus(); }
      else if (!event.shiftKey && document.activeElement === dernier) { event.preventDefault(); premier.focus(); }
    };
    document.addEventListener('keydown', surTouche);
    return () => document.removeEventListener('keydown', surTouche);
  }, [panneauRef, onClose]);
}
